import { Injectable } from '@angular/core';

import { AddResourcesModal } from '@app/flex-framework/components/modals/add-resources-modal/add-resources-modal.component';
import { ModalService } from '@app/shared/services/modal.service';
import { TargetsService } from '@app/shared/services/targets.service';
import { LearningResourceViewModel } from '@app/inputs/models/learning-resource.view-model';

import { Target } from '@app/target/target-api.model';
import { AddModalResults } from '@app/pathways/pathway-api.model';

import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

export interface AddResourcesConfig {
  target: Target;
  sectionNode: string;
  savedSearch?: LearningResourceViewModel[];
  hideFeatures?: boolean;
  exclusionList?: any[]; // TODO: type can be aligned with the flex-api.d.ts resourceType once that is updated
}

export interface AddResourcesModel extends AddResourcesConfig {
  onAddItems: (results: AddModalResults, callback: (data) => void) => void;
}

@Injectable({ providedIn: 'root' })
export class AddResourcesModalService {
  private selectedSearch: LearningResourceViewModel[] = [];

  constructor(
    private modalService: ModalService,
    private targetsService: TargetsService
  ) {}

  public openModal(
    addResourcesConfig: AddResourcesConfig
  ): Observable<AddModalResults> {
    addResourcesConfig.target = addResourcesConfig.target;
    const addResourcesModel: AddResourcesModel = {
      ...addResourcesConfig,
      ...{
        savedSearch: this.selectedSearch,
      },
      onAddItems: (modalResults, closeModal) => {
        this.selectedSearch = [];
        const references = modalResults.savedItems.map((result) => ({
          referenceId: result.resourceId,
          referenceType: result.resourceType,
          isEndorsed: result.isEndorsed,
        }));

        return this.targetsService
          .addTargetResources(
            addResourcesConfig.target,
            addResourcesConfig.sectionNode,
            references
          )
          .subscribe(() => closeModal(modalResults));
      },
    };
    return this.modalService
      .show(AddResourcesModal, {
        inputs: { addResourcesModel },
        errorOnDismiss: true,
        windowClass: 'xlg-modal',
      })
      .pipe(
        catchError((modalResults: AddModalResults) => {
          if (typeof modalResults !== 'object') {
            // modal was dismissed without saving
            return of({});
          }
          // if closing addContent modal, keep already selected items
          this.updateSelectedItems(modalResults.selectedSearch);
          return of();
        })
      );
  }

  public updateSelectedItems(selectedSearch: LearningResourceViewModel[]) {
    this.selectedSearch = selectedSearch;
  }
}
